import { StaticPropsValue } from "..";
import { CheckboxProperty } from "../input/checkbox-property";
import { TPropertyValue } from "../input/common";
import { StaticDropdownProperty } from "../input/dropdown/static-dropdown";
import { NumberProperty } from "../input/number-property";
import { PropertyType } from "../input/property-type";
import { ShortTextProperty, LongTextProperty } from "../input/text-property";
import { BasePieceAuthSchema } from "./common";
import { SecretTextProperty } from "./secret-text-property";
import { Type } from "@sinclair/typebox";



export type SwaggerFetchTokenAuthProps = Record<
	string,
	| ShortTextProperty<boolean>
	| LongTextProperty<boolean>
	| SecretTextProperty<boolean>
	| NumberProperty<boolean>
	| StaticDropdownProperty<unknown, boolean>
	| CheckboxProperty<boolean>
>

export type SwaggerFetchTokenAuthPropertyValue<T extends SwaggerFetchTokenAuthProps> = StaticPropsValue<T>;

export type SwaggerFetchTokenAuthPropertySchema<T extends SwaggerFetchTokenAuthProps> = BasePieceAuthSchema<SwaggerFetchTokenAuthPropertyValue<T>> & {
	url: string;
    method: string;
    in: string;
    name: string;
    prefix: string;
    refreshTokenOnError?: boolean;
    prefilledInputs?: Record<string, unknown>;
    tokenFieldName?: string;
    expiresInFieldName?: string;
	props: T
}

export type SwaggerFetchTokenAuthProperty<R extends boolean, T extends SwaggerFetchTokenAuthProps> = SwaggerFetchTokenAuthPropertySchema<T> & TPropertyValue<
	SwaggerFetchTokenAuthPropertyValue<T>,
	PropertyType.SWAGGER_FETCH_TOKEN_AUTH,
	R
>;

export const SwaggerFetchTokenAuthPropertySchema = Type.Object({
    url: Type.String(),
    method: Type.String(),
    in: Type.String(),
    name: Type.String(),
    prefix: Type.String(),
    type: Type.Literal(PropertyType.SWAGGER_FETCH_TOKEN_AUTH),
    refreshTokenOnError: Type.Boolean(),
    prefilledInputs: Type.Optional(Type.Record(Type.String(), Type.Any())),
    tokenFieldName: Type.Optional(Type.String()),
    expiresInFieldName: Type.Optional(Type.String()),
});